import React, { useState, useEffect } from 'react';

import {
    Box,
    Typography,
    Avatar,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Skeleton,
    TableContainer,
} from '@mui/material';


const projects = [
    {
        dpath: './assets/images/app-activity/icons/drive-icon.svg',
        dname: 'Google Drive',
        status: false,
        name: 'SkyGrid',
        desk: 'Worked Desk 1',
        initials: 'SG',
        color: '#6A1B9A',
        activity: 10,
        idle: 50,
        manual: 0,
        time: '10:36 am - 2:20 pm',
        duration: '3:44:13',
    },
    {
        dpath: './assets/images/app-activity/icons/figma-icon.svg',
        dname: 'Figma',
        status: 'unusual',
        name: 'Digital Marketing',
        desk: 'Worked Desk 3',
        initials: 'DM',
        color: '#1976D2',
        activity: 10,
        idle: 10,
        manual: 10,
        time: '2:21 pm - 3:23 pm',
        duration: '1:02:25',
    },
    {
        dpath: './assets/images/app-activity/icons/illustrator-icon.svg',
        dname: 'Adobe Illustrator 2024',
        status: false,
        name: 'CodeFusion',
        desk: 'Worked Desk 2',
        initials: 'CF',
        color: '#2E7D32',
        activity: 10,
        idle: 8,
        manual: 0,
        time: '5:55 pm - 7:12 pm',
        duration: '1:16:11',
    },
    {
        dpath: './assets/images/app-activity/icons/window-icon.svg',
        dname: 'Microsoft® Windows® Operating System',
        status: false,
        name: 'TerraGear',
        desk: 'Worked Desk 2',
        initials: 'TG',
        color: '#F57C00',
        activity: 10,
        idle: 50,
        manual: 0,
        time: '10:26 am - 3:06 pm',
        duration: '4:39:35',
    },
    {
        dpath: './assets/images/app-activity/icons/file-icon.svg',
        dname: 'Windows Explorer',
        status: false,
        name: 'HorizonGrove',
        desk: 'Worked Desk 6',
        initials: 'HG',
        color: '#5C6BC0',
        activity: 10,
        idle: 50,
        manual: 0,
        time: '9:54 am - 10:22 am',
        duration: '0:27:21',
    },
    {
        dpath: './assets/images/app-activity/icons/google-icon.svg',
        dname: 'Google Chrome',
        status: 'unusual',
        name: 'RiverGate',
        desk: 'Worked Desk 5',
        initials: 'RG',
        color: '#D32F2F',
        activity: 10,
        idle: 10,
        manual: 10,
        time: '10:25 am - 2:39 pm',
        duration: '4:14:39',
    },
];



const CustomCheckbox = ({ checked, onChange }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    border: '1px solid #D0D5DD',
                    backgroundColor: '#E5E8EB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);



const ActiveTable = () => {
    const [checkedStates, setCheckedStates] = useState({
        email: true,
        push: false,
        sms: false,
        figma: false,
        illust: true,
        window: false,
        file: true,
        google: true,
    });

    const handleChange = (key) => {
        setCheckedStates((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };



    const [loading, setLoading] = useState(true);
    const [selectedValues, setSelectedValues] = useState([]);


    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    const handleCheckboxChange = (name) => {
        setSelectedValues((prev) =>
            prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedValues(projects.map((p) => p.name));
        } else {
            setSelectedValues([]);
        }
    };


    return (
        <div>
            <Box display="flex" alignItems="center" sx={{ gap: '32px', margin: '24px auto 8px' }}>
                <Box display="flex" alignItems="center" sx={{ gap: '12px' }}>
                    <Typography component="a" href="/#" target="_blank" rel="noopener noreferrer" sx={{
                        fontSize: '12px', fontWeight: '500', backgroundColor: '#004DFF', padding: '4px 16px', borderRadius: '100px', color: '#fff', textDecoration: 'none', fontFamily:'Manrope',
                        '&:hover': {
                            color: '#fff', // Ensures white text on hover
                            backgroundColor: '#0036cc', // Optional: slightly darker blue on hover
                        },
                    }}>
                        Thu, May 1, 2025 ; 11:00 am - 12:00 pm</Typography>
                </Box>
                <Typography sx={{ fontSize: '14px', color: '#9095A1', fontWeight: '400', fontFamily:'Manrope' }}>Total time worked: <span style={{ color: '#373737' }}>0:27:36</span></Typography>
                <Typography sx={{ fontSize: '14px', color: '#9095A1', fontWeight: '400', fontFamily:'Manrope' }}>Total Session: <span style={{ color: '#373737' }}>24</span></Typography>
            </Box>

            <TableContainer sx={{ boxShadow: 'none' }}>
                <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', backgroundColor: '#f5f6fa', borderSpacing: '0 6px' }}>
                    <TableHead>
                        <TableRow sx={{
                            backgroundColor: '#DFDFDF',
                            '& th:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                            '& th:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                        }}>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }} padding="checkbox">
                                <CustomCheckbox
                                    checked={projects.length > 0 && selectedValues.length === projects.length}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>#</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Application</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Project</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }} align='center'>Session</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px', fontSize: '14px', color: '#626262', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }} align='center'>Duration</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>
                        {loading
                            ? [...Array(6)].map((_, i) => (
                                <TableRow key={i}>
                                    {[...Array(6)].map((_, j) => (
                                        <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                    ))}
                                </TableRow>
                            ))
                            : projects.map((project, index) => (
                                <TableRow key={index} sx={{
                                    borderRadius: '8px',
                                    '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap' }} padding="checkbox">
                                        <CustomCheckbox
                                            checked={selectedValues.includes(project.name)}
                                            onChange={() => handleCheckboxChange(project.name)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }}>{index + 1}</TableCell>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Avatar variant="rounded" sx={{ width: '30px', height: '30px', backgroundColor: 'unset', backgroundSize: 'cover', objectFit: 'cover' }}>
                                                <img src={project.dpath} className='img-fluid' alt='Drive Icon' sx={{ width: '30px', height: '30px', backgroundSize: 'cover', objectFit: 'cover' }} />
                                            </Avatar>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Typography sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>
                                                    {project.dname}
                                                </Typography>
                                                {project.status === 'unusual' && (
                                                    <Chip
                                                        label="Unusual"
                                                        size="small"
                                                        sx={{
                                                            fontSize: 12,
                                                            color: '#F44336',
                                                            backgroundColor: '#FD57574D',
                                                            fontWeight: 400,
                                                            height: '25px',
                                                            fontFamily: 'Manrope',
                                                        }}
                                                    />
                                                )}

                                                {/* <Chip
                                                    label="Unusual"
                                                    size="small"
                                                    sx={{
                                                        fontSize: 12,
                                                        color: '#F44336',
                                                        backgroundColor: '#FD57574D',
                                                        fontWeight: 400,
                                                        height: '25px',
                                                        fontFamily:'Manrope'
                                                    }}
                                                /> */}
                                            </Box>
                                        </Box>
                                    </TableCell>

                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap' }}>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Avatar sx={{ bgcolor: project.color, width: 30, height: 30, fontSize: 14 }}>
                                                {project.initials}
                                            </Avatar>
                                            <Box>
                                                <Typography fontSize={14} fontWeight={500} sx={{ fontFamily: 'Manrope' }}>
                                                    {project.name}
                                                </Typography>
                                                <Typography fontSize={12} color="text.secondary" sx={{ fontFamily: 'Manrope' }}>
                                                    {project.desk}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }} align='center'>50</TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }} align='center'>00:03:00</TableCell>

                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default ActiveTable
